import invariant from 'tiny-invariant'

import type { SelfAssessmentResult } from '@/src/domains/self-assessments/schemas'

export const getSelfAssessmentResult = (answers: number[], results: SelfAssessmentResult[]) => {
  const score = answers.reduce((total, answer) => total + answer, 0)
  const result = results.find(({ minScore, maxScore }) => score >= minScore && score <= maxScore)

  invariant(result, 'No self-assessment result configured')

  return result
}
